import { useDepStore } from "../stores";

export function closeWindow() {
  useDepStore.getState().opener?.postMessage({ message: "close-modal" }, "*");
}
